import { mergeObjectTypes } from '../cacheHelpers';

const RichDate = {
  merge: mergeObjectTypes
};

export default RichDate;
